import React from "react";
import { Link } from "react-router-dom";

function InfoPage({ eyebrow, title, subtitle, sections = [] }) {
  return (
    <main className="info-page">
      <header className="info-page-header">
        <Link to="/" className="info-back-link">
          ← Back to styles
        </Link>

        <p className="info-eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        <p className="info-subtitle">{subtitle}</p>
      </header>

      <div className="info-notice">
        <strong>Page under construction</strong>
        <p>
          This page contains placeholder content. Please replace it with
          your finalized information before publishing your website.
        </p>
      </div>

      <div className="info-sections">
        {sections.map((section) => (
          <section className="info-section" key={section.title}>
            <h2>{section.title}</h2>
            <p>{section.content}</p>
          </section>
        ))}
      </div>

      <div className="info-page-footer">
        <Link to="/" className="info-return-link">
          Explore our braid styles
        </Link>
      </div>
    </main>
  );
}

export default InfoPage;